var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cus-dialog",
    {
      staticClass: "base-confirm",
      attrs: {
        visible: _vm.showConfirm,
        title: null,
        close: _vm.closeUserProfile,
        isDisabledClose: "",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "base-confirm-body",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("div", { staticClass: "confirm-title base-flex" }, [
            _c("span", { staticClass: "tipIcon" }, [_vm._v("i")]),
            _c("span", { staticClass: "tipTitle base-text16" }, [
              _vm._v(_vm._s(_vm.$tran(_vm.title) || _vm.$tran("Tip"))),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "confirm-content", attrs: { tabindex: "0" } },
            [_vm._v(_vm._s(_vm.$tran(_vm.content)))]
          ),
          _c(
            "div",
            { staticClass: "confirm-footer base-flex-end" },
            [
              _c(
                "cus-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type.hideButton != `cancel`,
                      expression: "type.hideButton != `cancel`",
                    },
                  ],
                  attrs: { type: "cancel" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(_vm._s(_vm.$tran("Cancel")))]
              ),
              _c(
                "cus-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type.hideButton != `OK`,
                      expression: "type.hideButton != `OK`",
                    },
                  ],
                  attrs: { type: "confirm" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(_vm._s(_vm.$tran("Confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }